import { Block, Spacer, YouTube, Spotify } from "../../../../src/components/project/project";
import * as React from 'react';
export default {
  Block,
  Spacer,
  YouTube,
  Spotify,
  React
};